module.exports = __webpack_public_path__ + "static/media/6_Sample_House_new.dcf09406.jpg";